import { Component, OnInit } from '@angular/core';
import {
    DialogService,
    DynamicDialogConfig,
    DynamicDialogModule,
    DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { UserService } from '../../../../../../../../shared/services/user.service';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ToastService } from '../../../../../../../../shared/services/toast.service';
import { constants } from '../../../../../../../../shared/constants/constants';
import { HelperService } from '../../../../../../../../shared/services/helper.service';

@Component({
    selector: 'pay-rate-selector-modal',
    providers: [DialogService],
    standalone: true,
    imports: [
        FloatLabelModule,
        DialogModule,
        ButtonModule,
        FormsModule,
        CommonModule,
        DynamicDialogModule,
        InputNumberModule,
        RadioButtonModule,
    ],
    templateUrl: './pay-rate-selector-modal.component.html',
    styleUrl: './pay-rate-selector-modal.component.scss'
})
export class PayRateSelectorModalComponent implements OnInit {

    minValue: string = '';
    maxValue: string = '';
    payRateType: string = '';
    sessionUser: any = null;
    rateTypes: any = constants.roleRateType;

    constructor(
        public ref: DynamicDialogRef,
        private toastService: ToastService,
        public config: DynamicDialogConfig,
        private userService: UserService,
        private helperService: HelperService
    ) { }

    ngOnInit() {
        this.sessionUser = this.userService.getSessionUser();
        this.minValue = this.config?.data?.minPayRateValue;
        this.maxValue = this.config?.data?.maxPayRateValue;
        this.payRateType = this.config?.data?.selectedType;
        Object.keys(this.rateTypes).forEach((key) => {
            this.rateTypes[key] = this.helperService.capitalizeFirstLetter(
                String(this.rateTypes[key]).toLowerCase()
            );
        });
    }

    closeDialog() {
        if(!this.minValue || !this.maxValue){
            this.ref.close(false);
        }
        else{
            if(this.maxValue < this.minValue){
                this.toastService.showError('Maximum value can\'t be less than minimum value');
            }
            else{
                this.ref.close({type: this.payRateType, minValue: this.minValue, maxValue: this.maxValue});
            }
        }
    }
}
